import { AsyncPipe } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, Input, ViewChild } from '@angular/core';
import { ElementHostComponent } from '@components/element-widgets/element-host/element-host.component';
import { ElementHostOptions, TableType } from '@components/element-widgets/element-host/element-host.options';
import { TimeFrameSelectionComponent } from '@components/time-frame-selection/time-frame-selection.component';
import { ChartBindingDirective } from '@utils/chart-interactive/chart-controller.directive';
import { ChartTimeframeControllerDirective } from '@utils/chart-interactive/chart-timeframe-controller.directive';
import { DataToTimeframePipe } from '@utils/chart-interactive/data-to-timeframe.pipe';
import { TimeframePreselectionDirective } from '@utils/chart-interactive/timeframe-preselection.directive';
import { valueDevelopmentSimpleLinieOptionsTransformer } from '@utils/charts/chart-transformers';
import { HighchartsSizeStrategy } from '@utils/charts/highcharts.directive';
import { ApiCallInjectDirective } from 'src/app/common/directives/api-call-inject.directive';
import { ElementContentStringPipe } from 'src/app/element-handling/element-content-string.pipe';
import { ElementPipe } from 'src/app/element-handling/element.pipe';
import { ProvideElementsDirective } from 'src/app/element-handling/provide-elements.directive';
import { RouteSelectedFund } from '../selected-fund';
import { TableParametersPipe } from './table-parameters.pipe';

@Component({
  selector: 'wct-value-development-table',
  standalone: true,
  imports: [
    ElementHostComponent,
    TimeFrameSelectionComponent,

    ProvideElementsDirective,
    ChartBindingDirective,
    ChartTimeframeControllerDirective,
    TimeframePreselectionDirective,
    ApiCallInjectDirective,

    ElementPipe,
    ElementContentStringPipe,
    DataToTimeframePipe,
    AsyncPipe,
    TableParametersPipe,
  ],
  templateUrl: './value-development-table.component.html',
  styleUrl: './value-development-table.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ValueDevelopmentTableComponent {
  @Input({ required: true }) public documentId!: string;
  @Input({ required: true }) public reportIndex!: number;

  @ViewChild('tableRef', { read: ProvideElementsDirective, static: true })
  protected tableDocument!: ProvideElementsDirective;

  @ViewChild('chartRef', { read: ProvideElementsDirective, static: true })
  protected chartDocuments!: ProvideElementsDirective;

  protected readonly selectedFund = inject(RouteSelectedFund);

  protected readonly chartOptions: ElementHostOptions = {
    chartSizeStrategy: HighchartsSizeStrategy.FIT_CONTAINER_HEIGHT,
    chartOptionsTransformer: valueDevelopmentSimpleLinieOptionsTransformer,
    chartConstructerType: 'stockChart',
  };

  protected readonly tableOptions: ElementHostOptions = {
    tableType: TableType.SIMPLE,
  };

  protected readonly TABLE_ELEMENT: string = 'Kennzahlen';
  protected readonly VALUE_ELEMENT: string = 'Fondsvermoegen';

  protected readonly ProvideDocumentDirective = ProvideElementsDirective;
}
